module.exports = __webpack_public_path__ + "./img/OfertasInicio.42e76824d8b90805d3611a23fcccbf81.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/Help/OfertasInicio.png
// module id = ./public/img/Help/OfertasInicio.png
// module chunks = 0